import * as actionTypes from '../../snackBarActionTypes';
import { AppThunk } from '@greenkub-fronts/shared/interface';

export const addPositiveMessage =
  (content: any): AppThunk =>
  (dispatch, getState) => {
    const msgId = getState().snackbar.currentMessageId + 1;
    let messages = getState().snackbar.messages;

    if (content && typeof content === 'string') {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: 'positive',
          content: content,
        },
      ];
    }

    if (content && content.message && typeof content.message === 'string') {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: 'positive',
          content: content.message,
        },
      ];
    }

    dispatch({
      type: actionTypes.ADD_SNACK_MESSAGE,
      payload: {
        currentMessageId: msgId,
        messages,
      },
    });
  };
